<script>

  export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {

			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
  @import "./static/iconfont.css";
	/*每个页面公共css */
  @import "uni_modules/uview-ui/index.scss";

  page{
    background-color: #f8f8f8 !important;
  }
</style>
